import {HttpResponse} from '../../interfaces/api/http';
import {api} from '../api';
import {GetChatMessagesResponse} from '../../interfaces/api/qna';
import http from '../http';
import Config from 'react-native-config';

export interface ShareChatResponse extends HttpResponse {
  data: {
    token: string;
  };
}

/**
 * Content sharing services
 * Provides methods for sharing chats and other content
 */
export const share = {
  /**
   * Shares a chat with others by creating a public link
   * @param {string} id - ID of the chat to share
   * @returns {Promise<ShareChatResponse>} Promise resolving to share response with token
   */
  shareChat: (id: string): Promise<ShareChatResponse> =>
    new Promise((resolve, reject) => {
      http
        .post(api.qna.share, {
          model_id: id,
          type: Config.SHARE_FAVORITE_TYPE || 'Thread',
        })
        .then(res => resolve(res as ShareChatResponse))
        .catch(e => reject(e));
    }),

  /**
   * Retrieves message history for a shared chat
   * @param {string} [id] - ID of the shared chat to retrieve
   * @returns {Promise<GetChatMessagesResponse>} Promise resolving to chat messages
   */
  getChatHistory: (id?: string): Promise<GetChatMessagesResponse> =>
    new Promise((resolve, reject) => {
      const url = `${api.qna.publicChat}/${id}`;
      http
        .get(url)
        .then(res => resolve(res as unknown as GetChatMessagesResponse))
        .catch(e => reject(e));
    }),
};
